import { Swiper } from 'swiper';
import {Navigation, Pagination} from "swiper/modules";
Swiper.use([Navigation, Pagination]);

export default () => {
    const nodeSelectors = {
        container: '[js-slider-members="container"]',
        slider: '[js-slider-members="slider"]',
        pagination: '[js-slider-members="pagination"]',
        prev: '[js-slider="prev"]',
        next: '[js-slider="next"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                speed: 500,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },

                pagination: {
                    el: sliderEl.querySelector(nodeSelectors.pagination),
                    clickable: true,
                },
                breakpoints: {
                    600: {
                        slidesPerView: 2
                    },
                    1023: {
                        slidesPerView: 3
                    }
                }
            });
        })
    }

    return Object.freeze({
        init,
    })
}